module.exports = __webpack_public_path__ + "static/media/neutral-hover.4948d4c7.svg";